var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmenticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5L16 17C16 19.21 14.21 21 12 21C9.79 21 8 19.21 8 17L8 4.5C8 3.12 9.12 2 10.5 2C11.88 2 13 3.12 13 4.5L13 15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15L11 5.5L9.5 5.5L9.5 15C9.5 16.38 10.62 17.5 12 17.5C13.38 17.5 14.5 16.38 14.5 15L14.5 4.5C14.5 2.29 12.71 0.5 10.5 0.5C8.29 0.5 6.5 2.29 6.5 4.5L6.5 17C6.5 20.04 8.96 22.5 12 22.5C15.04 22.5 17.5 20.04 17.5 17L17.5 5.5L16 5.5Z",
    fill: "#768591"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 24) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmenticon);
export default __webpack_public_path__ + "static/media/Attachment.icon.beca6959388dfd979ec3207093ffada6.svg";
export { ForwardRef as ReactComponent };